import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA9-OYdqE1VwR1ZrtfREhdu2PhPlDnjqL8",
  authDomain: "simple-firebase-authenti-ec368.firebaseapp.com",
  projectId: "simple-firebase-authenti-ec368",
  storageBucket: "simple-firebase-authenti-ec368.appspot.com",
  messagingSenderId: "361535458306",
  appId: "1:361535458306:web:6753e7196833594123ab1b",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
